module.exports = __webpack_public_path__ + "img/print@2x.5881865.jpg";